export default {"src":"/_next/static/media/check--green.2563663e.svg","height":16,"width":16};